import React from "react";
import SwisscardProducts from "../../../../../resources/images/scd-footer-partners.svg";

import CustomTypography from "../../../../widgets/typography";
import "./styles.scss";
import { IssuerLinkProps, IssuerProps } from "./types";
import { Grid } from "@mui/material";
import CustomLink from "../../../../widgets/link";

const IssuerLink = ({ link: { text, url } }: { link: IssuerLinkProps }) => {
  return (
    <div className="scd-footer-link">
      <CustomLink noicon href={url} target="_blank" rel="noopener noreferrer">
        {text}
      </CustomLink>
    </div>
  );
};

const classNameBase = "scd-page-footer-issuer";

export default function Issuer({
  issuer,
  legalConditions,
  dataProtection,
}: IssuerProps): React.JSX.Element {
  return (
    <Grid container className={classNameBase}>
      <Grid
        container
        size={{ xs: 12, md: 9, lg: 9 }}
        direction="column"
        className={`${classNameBase}-info`}
      >
        <CustomTypography variant={"body2"}>{issuer}</CustomTypography>
        <CustomTypography
          variant={"body2"}
          className={`${classNameBase}-links`}
        >
          <IssuerLink link={legalConditions} />
          <span>|</span>
          <IssuerLink link={dataProtection} />
        </CustomTypography>
      </Grid>
      <Grid
        className={`${classNameBase}-logos`}
        size={{ xs: 12, md: 2, lg: 2 }}
      >
        <img src={SwisscardProducts} alt={"Swisscard"} />
      </Grid>
    </Grid>
  );
}
